import React from "react";
import { Login } from 'react-admin'
import LoginForm from './loginForm'

export default (props) => <Login
    {...props}
    children={<LoginForm />}
    backgroundImage={"https://demo3.nestrom.io/app/custom/img/login.png"}
    />
